import { memo, useEffect, useMemo, useState } from 'react'
import { globalClasses } from '@/styles'
import { FilterDropdownPopover } from '@/components/Data'
import { TimeRangeSliderDropdownProps } from './TimeRangeSliderDropdown.types'
import {
  TIME_RANGE_SLIDER_DEFAULT_MAX,
  TIME_RANGE_SLIDER_DEFAULT_MIN,
} from '../TimeRangeSlider/TimeRangeSlider.data'
import TimeRangeSlider from '../TimeRangeSlider/TimeRangeSlider'
import { useTimeRangeSlideUtils } from '../TimeRangeSlider/TimeRangeSlider.hooks'
import { TimeRangeValue } from '../TimeRangeSlider/TimeRangeSlider.types'

function TimeRangeSliderDropdown({
  isSelected = false,
  min = TIME_RANGE_SLIDER_DEFAULT_MIN,
  max = TIME_RANGE_SLIDER_DEFAULT_MAX,
  value,
  onChange,
  label,
  durationLabel,
  ...props
}: TimeRangeSliderDropdownProps) {
  const [timeRange, setTimeRange] = useState<TimeRangeValue>(value)
  const [minBound] = useState<number>(min)
  const [maxBound] = useState<number>(max)

  const { getDurationValueText } = useTimeRangeSlideUtils()

  const dropdownLabel = useMemo(() => {
    if (!isSelected) return label
    return `${label}: ${getDurationValueText({ value, min, max })}`
  }, [getDurationValueText, isSelected, label, max, min, value])

  useEffect(() => {
    setTimeRange({ min: value.min, max: value.max })
  }, [value.min, value.max])

  return (
    <FilterDropdownPopover
      label={dropdownLabel}
      isSelected={isSelected}
      contentWrapperProps={{
        className: globalClasses.fullWidth,
      }}
      popperProps={{
        placement: 'bottom-start',
      }}
      {...props}>
      <TimeRangeSlider
        title={label}
        durationLabel={durationLabel}
        min={minBound}
        max={maxBound}
        value={timeRange}
        onChange={(timeRangeValue) => {
          setTimeRange(timeRangeValue)
          onChange?.(timeRangeValue)
        }}
      />
    </FilterDropdownPopover>
  )
}

export default memo(TimeRangeSliderDropdown)
